import { DialogTitle, IconButton, Typography, Box, DialogProps } from '@mui/material'
import React from 'react'
import { makeStyles } from 'tss-react/mui'
import ResponsiveModalDrawerContainer from './ResponsiveModalDrawerContainer'
import ResponsiveModalDrawerActions, { ActionProps } from './ResponsiveModalDrawerActions'
import { J2Multiply } from '@e3dc-react/icons'

const useStyles = makeStyles()(theme => ({
  title: {
    padding: theme.spacing(4),
    paddingBottom: 0,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    [theme.breakpoints.down('sm')]: {
      padding: `0 ${theme.spacing(2)} ${theme.spacing(2)}`,
    },
  },
  icon: {
    [theme.breakpoints.down('sm')]: {
      fontSize: 30,
    },
  },
  body: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(4),
    overflow: 'auto',
    '& .MuiBox-root ': {
      display: 'flex',
      flexDirection: 'column',
    },

    [theme.breakpoints.down('sm')]: {
      paddingInline: 0,
      padding: theme.spacing(2),
    },
  },
}))

interface Props {
  children: React.ReactNode
  title: string
  onClose?: () => void
  secondaryAction: ActionProps
  primaryAction: ActionProps
  hasActions?: boolean
  leftControls?: React.ReactNode
  modalMaxWidth?: DialogProps['maxWidth']
  hasCloseButton?: boolean
  closableOnlyWithActionButtons?: boolean
}

/*
 * A responsive container that renders a modal drawer on mobile and a modal on desktop.
 */
const ResponsiveModalDrawerDialog = ({
  onClose,
  children,
  title,
  secondaryAction,
  primaryAction,
  leftControls,
  hasActions = true,
  modalMaxWidth,
  hasCloseButton = true,
  closableOnlyWithActionButtons = false,
}: Props): JSX.Element => {
  const { classes } = useStyles()

  return (
    <ResponsiveModalDrawerContainer modalMaxWidth={modalMaxWidth} closableOnlyWithActionButtons={closableOnlyWithActionButtons}>
      <DialogTitle className={classes.title}>
        <Box display="flex" flexDirection="row" alignItems="center">
          <Typography variant="h2" paddingRight={2}>
            {title}
          </Typography>
        </Box>
        {hasCloseButton && (
          <IconButton sx={{ color: 'grey.grey00' }} onClick={onClose}>
            <J2Multiply className={classes.icon} />
          </IconButton>
        )}
      </DialogTitle>
      <Box className={classes.body}>{children}</Box>
      {hasActions && <ResponsiveModalDrawerActions secondaryAction={secondaryAction} primaryAction={primaryAction} leftControls={leftControls} />}
    </ResponsiveModalDrawerContainer>
  )
}

export default ResponsiveModalDrawerDialog
